import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=b7f06bc4&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"
import style0 from "./Import.vue?vue&type=style&index=0&id=b7f06bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f06bc4",
  null
  
)

export default component.exports